import getEnv from "./getEnv";

export type RegistroEntregaRegrasEfetivas = {
  nomeRecebedorObrigatorio: boolean;
  fotoCanhotoObrigatoria: boolean;
  assinaturaRecebedorObrigatoria: boolean;
};

const REGRAS_LEGACY: RegistroEntregaRegrasEfetivas = {
  nomeRecebedorObrigatorio: false,
  fotoCanhotoObrigatoria: true,
  assinaturaRecebedorObrigatoria: false,
};

function parseDocumentosLista(raw: string | undefined): string[] {
  if (!raw || !String(raw).trim()) {
    return [];
  }
  return String(raw)
    .split(/[,;]/)
    .map((s) => s.trim().replace(/\D/g, ""))
    .filter(Boolean);
}

function documentosDigitosCorrespondem(a: string, b: string): boolean {
  const da = String(a || "").replace(/\D/g, "");
  const db = String(b || "").replace(/\D/g, "");
  if (da == "" || db == "") {
    return false;
  }
  if (da == db) {
    return true;
  }
  if (da.length <= 11 && db.length <= 11) {
    return da.padStart(11, "0") == db.padStart(11, "0");
  }
  if (da.length <= 14 && db.length <= 14) {
    return da.padStart(14, "0") == db.padStart(14, "0");
  }
  return false;
}

function flagsDasVariaveisDeAmbiente(): RegistroEntregaRegrasEfetivas {
  return {
    nomeRecebedorObrigatorio:
      getEnv("REACT_APP_REGISTRO_ENTREGA_NOME_RECEBEDOR_OBRIGATORIO") === "true",
    fotoCanhotoObrigatoria:
      getEnv("REACT_APP_REGISTRO_ENTREGA_FOTO_CANHOTO_OBRIGATORIA") === "true",
    assinaturaRecebedorObrigatoria:
      getEnv("REACT_APP_REGISTRO_ENTREGA_ASSINATURA_RECEBEDOR_OBRIGATORIA") ===
      "true",
  };
}

export function resolveRegistroEntregaRegras(
  documentoParceiro: string | undefined
): RegistroEntregaRegrasEfetivas {
  const regrasParaTodos =
    getEnv("REACT_APP_REGISTRO_ENTREGA_REGRAS_PARA_TODOS") === "true";
  if (regrasParaTodos) {
    return flagsDasVariaveisDeAmbiente();
  }

  const doc = (documentoParceiro || "").replace(/\D/g, "");
  const restricao = parseDocumentosLista(
    getEnv("REACT_APP_REGISTRO_ENTREGA_APLICAR_REGRAS_APENAS_CPFS")
  );
  const parceiroNaLista =
    restricao.length == 0 ||
    restricao.some((c) => documentosDigitosCorrespondem(c, doc));
  if (!parceiroNaLista) {
    return { ...REGRAS_LEGACY };
  }
  return flagsDasVariaveisDeAmbiente();
}
